import { cn } from "@/lib/utils/cn";

type Tone = "accent" | "money" | "muted" | "white" | "green";

const FILL: Record<Tone, string> = {
  accent: "bg-green",
  green: "bg-green",
  money: "bg-forest",
  muted: "bg-slate",
  white: "bg-white",
};

export function Progress({
  value,
  className,
  height = 8,
  tone = "green",
  trackClassName,
}: {
  value: number; // 0–100
  className?: string;
  height?: number;
  tone?: Tone;
  /** Override track bg — used for purple goal block where track is `bg-white/30`. */
  trackClassName?: string;
}) {
  return (
    <div
      className={cn(
        "w-full overflow-hidden rounded-full",
        trackClassName ?? "bg-[#E9F1EB]",
        className,
      )}
      style={{ height }}
      role="progressbar"
      aria-valuenow={Math.round(value)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={cn(
          "h-full rounded-full transition-[width] duration-500 ease-out",
          FILL[tone],
        )}
        style={{ width: `${Math.max(0, Math.min(100, value))}%` }}
      />
    </div>
  );
}
